import { render, staticRenderFns } from "./discountList.vue?vue&type=template&id=826352b8&scoped=true&"
import script from "./discountList.vue?vue&type=script&lang=js&"
export * from "./discountList.vue?vue&type=script&lang=js&"
import style0 from "./discountList.vue?vue&type=style&index=0&id=826352b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826352b8",
  null
  
)

export default component.exports